module.exports = __webpack_public_path__ + "media/images/hitfun/sample.quizscreen.image-af275809167b3c4f81790020fbac3664.jpg";